<template>
  <div class="footer_container">
    <div class="left">
      ©2021-2023 上海丞乐网络科技有限公司版本所有
    </div>
    <div class="right" @click="toOpen">
      沪ICP备18026676号
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toOpen() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  }
}
</script>
<style lang="less" scoped>
.footer_container {
  margin-top: -20px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: rgba(0, 0, 0, 0.59);
  display: flex;
  justify-content: center;
  color: white;
  font-weight: 400;

  .right {
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
